module.exports = "/assets/images/truck_eb5292.svg";